<script lang="ts">
  export let visible: boolean = false;
  export let customClass: string = "";
</script>

<div
  class="
    flex w-full h-full {customClass} {!visible
    ? 'hidden'
    : ''}
  "
>
  <div class="spinner spinOuter">
    <div class="inner spinInner"></div>
  </div>
</div>

<style lang="postcss">
  .spinner {
    width: 24px;
    height: 24px;
    position: relative;
    border-top: 2px solid #cadfe0;
    border-right: 2px solid transparent;
    border-bottom: 2px solid transparent;
    border-left: 2px solid transparent;
    border-radius: 50%;
  }

  .spinOuter {
    animation: spinRight 1.5s linear infinite;
  }

  .spinInner {
    animation: spinLeft 4.5s linear infinite;
  }

  .inner {
    width: 20px;
    height: 20px;
    position: absolute;
    left: 1px;
    top: 1px;
    border-top: 2px solid #cadfe0;
    border-right: 2px solid transparent;
    border-bottom: 2px solid transparent;
    border-left: 2px solid transparent;
    border-radius: 50%;
  }

  @keyframes spinRight {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes spinLeft {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(720deg);
    }
  }
</style>
